
import React from 'react';
import { useTranslation } from 'react-i18next';
import MainLayout from '@/components/layout/MainLayout';
import DashboardStats from '@/components/dashboard/DashboardStats';
import UnpaidClientsList from '@/components/dashboard/UnpaidClientsList';
import LowSessionsList from '@/components/dashboard/LowSessionsList';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { AlertTriangle, CreditCard, Users } from 'lucide-react';

const Dashboard: React.FC = () => {
  const { t } = useTranslation();

  console.log('Dashboard component rendering');

  return (
    <MainLayout>
      <div className="container mx-auto p-3 md:p-4 space-y-4 md:space-y-6">
        <div className="flex flex-col gap-1 md:gap-2">
          <h1 className="text-xl md:text-2xl lg:text-3xl font-bold">
            {t('dashboard.title')}
          </h1>
          <p className="text-sm md:text-base text-muted-foreground">{t('dashboard.subtitle')}</p>
        </div>

        <Tabs defaultValue="unpaid" className="w-full">
          <TabsList className="grid w-full grid-cols-2 h-9 md:h-10">
            <TabsTrigger value="unpaid" className="flex items-center gap-1 md:gap-2 text-xs md:text-sm">
              <CreditCard className="h-3 w-3 md:h-4 md:w-4" />
              <span className="hidden sm:inline">
                {t('dashboard.unpaidClients')}
              </span>
              <span className="sm:hidden">{t('dashboard.unpaid')}</span>
            </TabsTrigger>
            <TabsTrigger
              value="lowSessions"
              className="flex items-center gap-1 md:gap-2 text-xs md:text-sm"
            >
              <AlertTriangle className="h-3 w-3 md:h-4 md:w-4" />
              <span className="hidden sm:inline">
                {t('dashboard.lowSessions')}
              </span>
              <span className="sm:hidden">{t('dashboard.low')}</span>
            </TabsTrigger>
          </TabsList>

          <TabsContent value="unpaid" className="space-y-3 md:space-y-4">
            <Card>
              <CardHeader className="pb-3 md:pb-6">
                <CardTitle className="flex items-center gap-2 text-base md:text-lg">
                  <CreditCard className="h-4 w-4 md:h-5 md:w-5" />
                  {t('dashboard.unpaidClients')}
                </CardTitle>
                <CardDescription className="text-xs md:text-sm">
                  {t('dashboard.unpaidClientsDescription')}
                </CardDescription>
              </CardHeader>
              <CardContent className="pt-0">
                <UnpaidClientsList />
              </CardContent>
            </Card>
          </TabsContent>

          <TabsContent value="lowSessions" className="space-y-3 md:space-y-4">
            <Card>
              <CardHeader className="pb-3 md:pb-6">
                <CardTitle className="flex items-center gap-2 text-base md:text-lg">
                  <AlertTriangle className="h-4 w-4 md:h-5 md:w-5" />
                  {t('dashboard.lowSessions')}
                </CardTitle>
                <CardDescription className="text-xs md:text-sm">
                  {t('dashboard.lowSessionsDescription')}
                </CardDescription>
              </CardHeader>
              <CardContent className="pt-0">
                <LowSessionsList />
              </CardContent>
            </Card>
          </TabsContent>
        </Tabs>

        <DashboardStats />
      </div>
    </MainLayout>
  );
};

export default Dashboard;
